export default {
  ADDRESS: (state) => state.address,
};
